
import { mapGetters } from "vuex";

export default {
  props: {
    product: { type: Object, required: true },
    selectedVariant: { type: Object, default: () => ({}) },
    cmsData: { type: Object, default: () => ({}) },
  },

  computed: {
    ...mapGetters("bag", ["lines"]),
    selectedVariantIds: {
      get() {
        return this.$store.state.pdp.customizations;
      },
      set(value) {
        this.$store.dispatch("pdp/updateCustomization", value);
      },
    },
  },

  watch: {
    selectedVariant() {
      this.selectedVariantIds = [];
    },
  },

  methods: {
    handleClick({ id }) {
      this.selectedVariantIds = this.selectedVariantIds.includes(id)
        ? this.selectedVariantIds.filter(vid => vid !== id)
        : [...this.selectedVariantIds, id];
    },
  },
};
